import find from 'lodash/find';
import union from 'lodash/union';

import individualTest from '../../../constants/json/checkboxes/individualTest.json';

const config = [
  {
    colId: 'class',
    headerName: 'Class',
    field: 'class',
    suppressHeaderMenuButton: true,
    width: 300,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'font-weight': 'normal' },
    cellRenderer: params => {
      if (params.value !== '') {
        return params.value;
      } else {
        return '<img src="https://raw.githubusercontent.com/ag-grid/ag-grid-docs/master/src/images/loading.gif">';
      }

    },
    sortable: true,
    sort: 'asc',
     comparator: (a, b, nodeA, nodeB, isInverted) => {
    // Use the same logic as valueFormatter to get the display value for sorting
    const getDisplayValue = (value, data) => {
      if (value) {
        if (typeof value === 'string') {
          return value;
        } else {
          const chemicalClass =
            value &&
            find(
              union(
                individualTest[0].common,
                individualTest[0].toys,
                individualTest[0].electronic,
                individualTest[0].packaging,
                individualTest[0].jewelry
              ),
              ['id', value]
            )?.label;
          return chemicalClass || '';
        }
      }
      return data?.chemicalClass || '';
    };
    const valA = getDisplayValue(a, nodeA?.data);
    const valB = getDisplayValue(b, nodeB?.data);
    return valA.localeCompare(valB, undefined, { sensitivity: 'base' });
  },
    tooltip: (params) => params.value,
    suppressMovable: true,
    valueGetter: params => {
      let renderedText = '';
      if (params.data && params.data.class) {
        renderedText = find(
          union(
            individualTest[0].common,
            individualTest[0].toys,
            individualTest[0].electronic,
            individualTest[0].packaging,
            individualTest[0].jewelry
          ),
          ['id', params.data.class]
        ).label;
      }
      return renderedText;
    }
  },
  {
    colId: 'chemicalName',
    headerName: 'Chemical Name',
    field: 'chemicalName',
    width: 250,
    tooltip: (params) => params.value,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'font-weight': 'normal' },
    sortable: true,
    sort: 'asc',
    comparator: (a, b) => {      
      return (a || '').localeCompare(b || '', undefined, { sensitivity: 'base' });
    }

  },
  {
    colId: 'casNo',
    headerName: 'CAS No',
    field: 'casNo',
    tooltip: (params) => params.value,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'white-space': 'normal', 'font-weight': 'normal' },
  },
  {
    colId: 'labLimit',
    headerName: 'Lab Reporting Limit',
    field: 'labLimit',
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    tooltip: (params) => params.value,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'white-space': 'normal', 'font-weight': 'normal' },
    valueFormatter: (params) => params.value
  },
  {
    colId: 'nikeLimit',
    headerName: 'Nike Limit',
    field: 'nikeLimit',
    width: 250,
    tooltip: (params) => params.value,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'font-weight': 'normal' },
    valueFormatter: (params) => params.value
  },
  {
    colId: 'result',
    headerName: 'Result/UOM',
    field: 'result',
    width: 300,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    tooltip: (params) => params.value,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: {'font-weight': 'normal' },
    valueGetter: params => {
      let renderedText = params.data && params.data.result;
      renderedText = params.data && params.data.unit ? `${renderedText} ${params.data.unit}` : renderedText;
      const classValue = 532;
      const classValueAsbestos = 504;
      if (params.data && params.data.result !== ' ') {
        if (params.data.class === classValue || params.data.class === classValueAsbestos) {
          if (params.data.result === -2) {
            renderedText = 'Present';
          } else if (params.data.result === -3) {
            renderedText = 'Absent';
          } else {
            renderedText = 'Invalid Test Result Value '
          }
        } else if (params.data.result < 0) {
          if (params.data.result === -4) {
            renderedText = 'Not Tested';
          }
          else if (params.data.result === -1) {
            renderedText = 'Not Detected';
          }
          else {
            renderedText = 'Invalid Test Result Value '
          }
        }
      }
      return renderedText;
    }
  },
  {
    colId: 'status',
    headetoName: 'PASS/FAIL',
    field: 'status',
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    tooltip: (params) => params.value,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'white-space': 'normal', 'font-weight': 'normal' },
  }
];
export default config;